// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Key Metrics Grid Layout */
.key-metrics-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* Two-column layout */
  gap: 20px;
  padding: 15px;
  margin-top: -15px;
  margin-left: -18px;
}

/* Metric Card Styling */
.metric-card {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 15px;
  display: flex;
  flex-direction: column;
  justify-content: start;
  position: relative;
  margin-bottom: 15px;
  width: auto;
  margin-left: -12px;
  height: 140px;
  min-width: 300px;
  max-width: 420px;
}

.metric-header-sentiment {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px;
  text-transform: uppercase;
  position: absolute;
  top: -170px;
  left: -547px;
}

.metric-header-resultgraph{
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px;
  text-transform: uppercase;
  position: absolute;
  top: -170px;
  left: -547px;
} 

/* Header and Icon Alignment */
.metric-card-header {
  display: flex;
  margin-top: -10px;
  justify-content: space-between;
  align-items: center;
  position: relative;
}

.short-metric-card-header {
  margin-top: -29px;
}

/* Icons for Fullscreen and Layout */
.card-icons {
  position: absolute;
  top: 10px;
  right: 10px;
}

.card-icons-sentiment {
  position: absolute;
  top: -170px;
  right: -550px;

}

.card-icons-resultgraph{
  position: absolute;
  top: -170px;
  right: -550px;
}

.card-icons .icon {
  font-size: 18px;
  cursor: pointer;
  margin-left: 5px;
}

/* Separator Line */
.separator {
  height: 2px;
  background-color: #c0c0c0; /* Light silver color */
  margin-bottom: 20px;
  width: 100%; /* Ensures the line is straight across the container */
}



/* Metric Value Styling */
.metric-value {
  text-align: center;
  font-size: 42px; /* Increased font size */
  font-weight: bold;
}

/* Sentiment Values Layout */
.sentiment-values {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 10px;
}

/* Sentiment Positive and Negative Sections */
.positive-sentiment,
.negative-sentiment {
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* Sentiment Icon Styling */
.sentiment-icon {
  font-size: 24px;
}

/* Chart Container Styling */
.chart-container {
  background-color: #f4f4f4;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: inline-block;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 325px;
  width: 1075px;
  margin-left: 0px;
  margin-right: 100px;
}

/* Adjusting Spacing Between Graphs */
.chart-container + .chart-container {
  margin-top: 10px; /* Ensure consistent spacing between graphs */
}

/* Results Graph Container */
.chart-container-resultgraph {
  grid-row: span 1; /* Align next to metrics */
}

.graph-container {
  margin-top: -62px; /* Adjust to move graph higher */
}


/* Net Sentiment Graph Container */
.chart-container-netsentiment {
  grid-row: span 1; /* Align next to metrics */
}


#graph-lan-chart {
  background: white;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  margin-top: 20px;
  width: 88.5%;
}

#graph-lan-chart .metric-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 10px;
  border-bottom: 2px solid #f0f0f0;
}

.fullscreen-value {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  padding: 20px;
  gap: 20px; /* Adding spacing between platform cards */
}

/* Each platform card */
/* Platform Card Styling */
.platform-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-left: 50px;
  padding-right: 50px;
  /* background-color: #20202091; */
  border-radius: 10px;
  /* box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); */
  text-align: center;
}

/* Icon Container Styling */
.keymetrics-icon-container {
  margin-bottom: 10px;
}

/* Default Icon Styling */
.platform-icon {
  width: 50px;
  height: 100px;
  transition: all 0.3s ease; /* Smooth transition for hover effects */
}



/* Twitter Icon Color */
.platform-card .fa-twitter {
  color: #1DA1F2 !important; /* Twitter's blue color */
}

/* Facebook Icon Color */
.platform-card .fa-facebook {
  color: #3b5998; /* Facebook's blue color */
}

/* Instagram Icon Color */
.platform-card .fa-instagram {
  color: #E4405F; /* Instagram's pink color */
}

/* TikTok Icon Color */
.platform-card .fa-tiktok {
  color: #000000; /* TikTok's black color */
}

/* Hover Effect for Icons */
.platform-icon:hover {
  transform: scale(1.1); /* Slightly enlarge the icon on hover */
  cursor: pointer; /* Change cursor on hover */
}




.modal-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.close-icon {
  font-size: 24px;
  /* cursor: pointer;
  margin-top: -50%; */
  /* margin-left: 98%; */
}







/* Main container for the word cloud */
#world-cloud {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  
  color: black;
  position: relative;
}

/* Ensures the word cloud chart is centered */
.chart-container-content {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 400px; /* Adjust height as needed */
  position: relative;
}

/* Platform Selector (Radio Buttons) */
.platform-selector {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  padding: 10px;
  background-color: #222;
  border-radius: 10px;
  margin-top: 20px;
}
/* Styling for each radio button */
.platform-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  color: white;
}

/* Hide the default radio button */
.platform-label input {
  display: none;
}

/* Colored circle indicator for each platform */
.platform-circle {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 8px;
}

/* New Grid Layout for Metric Cards */
.metric-multi-value {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* Ensure 2 columns layout */
  gap: 5px; /* Reduce spacing for compact fit */
  padding: 8px;
  width: 100%; /* Keep it inside the card */
  margin-top: -42px;
}

/* Smaller platform metric boxes */
.platform-metric {
  display: flex;
  flex-direction: column; /* Stack icon & value */
  align-items: center;
  justify-content: center;
  background: #ffffff;
  padding: 5px; /* Reduce padding */
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1); /* Lighter shadow */
  font-size: 12px; /* Adjust font size for compact view */
  font-weight: bold;
  color: #333;
  height: 50px; /* Reduce height to fit card */
  position: relative; /* Needed for fine-tuning */
}


.platform-metric span {
  margin-bottom: 10px; /* Move value slightly up */
}
/* Icons are smaller but still visible */
.platform-metric .platform-icon {
  font-size: 16px; /* Increase size slightly */
  margin-bottom: -5px; /* Move icon closer to value */
  position: absolute;
  top: 16px; /* Adjust top position for better alignment */
  left: 50px;
  transform: translateX(-50%);
}

/* Twitter Icon */
.platform-metric .fa-twitter {
  color: #1DA1F2 !important; /* Twitter blue */
}

/* Facebook Icon */
.platform-metric .fa-facebook {
  color: #1877F2 !important; /* Facebook blue */
}

/* Instagram Icon */
.platform-metric .fa-instagram {
  color: #E4405F !important; /* Instagram pink */
}

/* TikTok Icon */
.platform-metric .fa-tiktok {
  color: #000000 !important; /* TikTok black */
}

`, "",{"version":3,"sources":["webpack://./src/analytics/keymetrics.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,aAAa;EACb,qCAAqC,EAAE,sBAAsB;EAC7D,SAAS;EACT,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;;AAEf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,yBAAyB,EAAE,uBAAuB;EAClD,mBAAmB;EACnB,WAAW,EAAE,sDAAsD;AACrE;;;;AAIA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,eAAe,EAAE,wBAAwB;EACzC,iBAAiB;AACnB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,6CAA6C;AAC7C;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,eAAe;AACjB;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;EACxC,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,qCAAqC;AACrC;EACE,gBAAgB,EAAE,6CAA6C;AACjE;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB,EAAE,0BAA0B;AAC9C;;AAEA;EACE,iBAAiB,EAAE,gCAAgC;AACrD;;;AAGA,kCAAkC;AAClC;EACE,gBAAgB,EAAE,0BAA0B;AAC9C;;;AAGA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,uCAAuC;EACvC,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,aAAa;EACb,SAAS,EAAE,0CAA0C;AACvD;;AAEA,uBAAuB;AACvB,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,iCAAiC;EACjC,mBAAmB;EACnB,8CAA8C;EAC9C,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,aAAa;EACb,yBAAyB,EAAE,wCAAwC;AACrE;;;;AAIA,uBAAuB;AACvB;EACE,yBAAyB,EAAE,yBAAyB;AACtD;;AAEA,wBAAwB;AACxB;EACE,cAAc,EAAE,0BAA0B;AAC5C;;AAEA,yBAAyB;AACzB;EACE,cAAc,EAAE,2BAA2B;AAC7C;;AAEA,sBAAsB;AACtB;EACE,cAAc,EAAE,yBAAyB;AAC3C;;AAEA,2BAA2B;AAC3B;EACE,qBAAqB,EAAE,uCAAuC;EAC9D,eAAe,EAAE,2BAA2B;AAC9C;;;;;AAKA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf;qBACmB;EACnB,sBAAsB;AACxB;;;;;;;;AAQA,sCAAsC;AACtC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;;EAEvB,YAAY;EACZ,kBAAkB;AACpB;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,aAAa,EAAE,4BAA4B;EAC3C,kBAAkB;AACpB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;AACA,kCAAkC;AAClC;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA,kCAAkC;AAClC;EACE,aAAa;AACf;;AAEA,+CAA+C;AAC/C;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,qCAAqC,EAAE,4BAA4B;EACnE,QAAQ,EAAE,mCAAmC;EAC7C,YAAY;EACZ,WAAW,EAAE,4BAA4B;EACzC,iBAAiB;AACnB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,sBAAsB,EAAE,uBAAuB;EAC/C,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY,EAAE,mBAAmB;EACjC,kBAAkB;EAClB,wCAAwC,EAAE,mBAAmB;EAC7D,eAAe,EAAE,sCAAsC;EACvD,iBAAiB;EACjB,WAAW;EACX,YAAY,EAAE,8BAA8B;EAC5C,kBAAkB,EAAE,2BAA2B;AACjD;;;AAGA;EACE,mBAAmB,EAAE,2BAA2B;AAClD;AACA,wCAAwC;AACxC;EACE,eAAe,EAAE,2BAA2B;EAC5C,mBAAmB,EAAE,8BAA8B;EACnD,kBAAkB;EAClB,SAAS,EAAE,6CAA6C;EACxD,UAAU;EACV,2BAA2B;AAC7B;;AAEA,iBAAiB;AACjB;EACE,yBAAyB,EAAE,iBAAiB;AAC9C;;AAEA,kBAAkB;AAClB;EACE,yBAAyB,EAAE,kBAAkB;AAC/C;;AAEA,mBAAmB;AACnB;EACE,yBAAyB,EAAE,mBAAmB;AAChD;;AAEA,gBAAgB;AAChB;EACE,yBAAyB,EAAE,iBAAiB;AAC9C","sourcesContent":["/* Key Metrics Grid Layout */\r\n.key-metrics-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, 1fr); /* Two-column layout */\r\n  gap: 20px;\r\n  padding: 15px;\r\n  margin-top: -15px;\r\n  margin-left: -18px;\r\n}\r\n\r\n/* Metric Card Styling */\r\n.metric-card {\r\n  background-color: #fff;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n  padding: 15px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: start;\r\n  position: relative;\r\n  margin-bottom: 15px;\r\n  width: auto;\r\n  margin-left: -12px;\r\n  height: 140px;\r\n  min-width: 300px;\r\n  max-width: 420px;\r\n}\r\n\r\n.metric-header-sentiment {\r\n  font-size: 24px;\r\n  font-weight: bold;\r\n  margin-bottom: 10px;\r\n  text-transform: uppercase;\r\n  position: absolute;\r\n  top: -170px;\r\n  left: -547px;\r\n}\r\n\r\n.metric-header-resultgraph{\r\n  font-size: 24px;\r\n  font-weight: bold;\r\n  margin-bottom: 10px;\r\n  text-transform: uppercase;\r\n  position: absolute;\r\n  top: -170px;\r\n  left: -547px;\r\n} \r\n\r\n/* Header and Icon Alignment */\r\n.metric-card-header {\r\n  display: flex;\r\n  margin-top: -10px;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  position: relative;\r\n}\r\n\r\n.short-metric-card-header {\r\n  margin-top: -29px;\r\n}\r\n\r\n/* Icons for Fullscreen and Layout */\r\n.card-icons {\r\n  position: absolute;\r\n  top: 10px;\r\n  right: 10px;\r\n}\r\n\r\n.card-icons-sentiment {\r\n  position: absolute;\r\n  top: -170px;\r\n  right: -550px;\r\n\r\n}\r\n\r\n.card-icons-resultgraph{\r\n  position: absolute;\r\n  top: -170px;\r\n  right: -550px;\r\n}\r\n\r\n.card-icons .icon {\r\n  font-size: 18px;\r\n  cursor: pointer;\r\n  margin-left: 5px;\r\n}\r\n\r\n/* Separator Line */\r\n.separator {\r\n  height: 2px;\r\n  background-color: #c0c0c0; /* Light silver color */\r\n  margin-bottom: 20px;\r\n  width: 100%; /* Ensures the line is straight across the container */\r\n}\r\n\r\n\r\n\r\n/* Metric Value Styling */\r\n.metric-value {\r\n  text-align: center;\r\n  font-size: 42px; /* Increased font size */\r\n  font-weight: bold;\r\n}\r\n\r\n/* Sentiment Values Layout */\r\n.sentiment-values {\r\n  display: flex;\r\n  justify-content: space-around;\r\n  align-items: center;\r\n  margin-top: 10px;\r\n}\r\n\r\n/* Sentiment Positive and Negative Sections */\r\n.positive-sentiment,\r\n.negative-sentiment {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\n/* Sentiment Icon Styling */\r\n.sentiment-icon {\r\n  font-size: 24px;\r\n}\r\n\r\n/* Chart Container Styling */\r\n.chart-container {\r\n  background-color: #f4f4f4;\r\n  border-radius: 8px;\r\n  padding: 15px;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n  display: inline-block;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 325px;\r\n  width: 1075px;\r\n  margin-left: 0px;\r\n  margin-right: 100px;\r\n}\r\n\r\n/* Adjusting Spacing Between Graphs */\r\n.chart-container + .chart-container {\r\n  margin-top: 10px; /* Ensure consistent spacing between graphs */\r\n}\r\n\r\n/* Results Graph Container */\r\n.chart-container-resultgraph {\r\n  grid-row: span 1; /* Align next to metrics */\r\n}\r\n\r\n.graph-container {\r\n  margin-top: -62px; /* Adjust to move graph higher */\r\n}\r\n\r\n\r\n/* Net Sentiment Graph Container */\r\n.chart-container-netsentiment {\r\n  grid-row: span 1; /* Align next to metrics */\r\n}\r\n\r\n\r\n#graph-lan-chart {\r\n  background: white;\r\n  border-radius: 10px;\r\n  padding: 20px;\r\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\r\n  margin-top: 20px;\r\n  width: 88.5%;\r\n}\r\n\r\n#graph-lan-chart .metric-card-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding-bottom: 10px;\r\n  border-bottom: 2px solid #f0f0f0;\r\n}\r\n\r\n.fullscreen-value {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: space-around;\r\n  padding: 20px;\r\n  gap: 20px; /* Adding spacing between platform cards */\r\n}\r\n\r\n/* Each platform card */\r\n/* Platform Card Styling */\r\n.platform-card {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  padding-left: 50px;\r\n  padding-right: 50px;\r\n  /* background-color: #20202091; */\r\n  border-radius: 10px;\r\n  /* box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); */\r\n  text-align: center;\r\n}\r\n\r\n/* Icon Container Styling */\r\n.keymetrics-icon-container {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n/* Default Icon Styling */\r\n.platform-icon {\r\n  width: 50px;\r\n  height: 100px;\r\n  transition: all 0.3s ease; /* Smooth transition for hover effects */\r\n}\r\n\r\n\r\n\r\n/* Twitter Icon Color */\r\n.platform-card .fa-twitter {\r\n  color: #1DA1F2 !important; /* Twitter's blue color */\r\n}\r\n\r\n/* Facebook Icon Color */\r\n.platform-card .fa-facebook {\r\n  color: #3b5998; /* Facebook's blue color */\r\n}\r\n\r\n/* Instagram Icon Color */\r\n.platform-card .fa-instagram {\r\n  color: #E4405F; /* Instagram's pink color */\r\n}\r\n\r\n/* TikTok Icon Color */\r\n.platform-card .fa-tiktok {\r\n  color: #000000; /* TikTok's black color */\r\n}\r\n\r\n/* Hover Effect for Icons */\r\n.platform-icon:hover {\r\n  transform: scale(1.1); /* Slightly enlarge the icon on hover */\r\n  cursor: pointer; /* Change cursor on hover */\r\n}\r\n\r\n\r\n\r\n\r\n.modal-content {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n}\r\n\r\n.close-icon {\r\n  font-size: 24px;\r\n  /* cursor: pointer;\r\n  margin-top: -50%; */\r\n  /* margin-left: 98%; */\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n/* Main container for the word cloud */\r\n#world-cloud {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  \r\n  color: black;\r\n  position: relative;\r\n}\r\n\r\n/* Ensures the word cloud chart is centered */\r\n.chart-container-content {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 100%;\r\n  height: 400px; /* Adjust height as needed */\r\n  position: relative;\r\n}\r\n\r\n/* Platform Selector (Radio Buttons) */\r\n.platform-selector {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 20px;\r\n  padding: 10px;\r\n  background-color: #222;\r\n  border-radius: 10px;\r\n  margin-top: 20px;\r\n}\r\n/* Styling for each radio button */\r\n.platform-label {\r\n  display: flex;\r\n  align-items: center;\r\n  cursor: pointer;\r\n  font-size: 16px;\r\n  font-weight: bold;\r\n  color: white;\r\n}\r\n\r\n/* Hide the default radio button */\r\n.platform-label input {\r\n  display: none;\r\n}\r\n\r\n/* Colored circle indicator for each platform */\r\n.platform-circle {\r\n  width: 15px;\r\n  height: 15px;\r\n  border-radius: 50%;\r\n  display: inline-block;\r\n  margin-right: 8px;\r\n}\r\n\r\n/* New Grid Layout for Metric Cards */\r\n.metric-multi-value {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, 1fr); /* Ensure 2 columns layout */\r\n  gap: 5px; /* Reduce spacing for compact fit */\r\n  padding: 8px;\r\n  width: 100%; /* Keep it inside the card */\r\n  margin-top: -42px;\r\n}\r\n\r\n/* Smaller platform metric boxes */\r\n.platform-metric {\r\n  display: flex;\r\n  flex-direction: column; /* Stack icon & value */\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: #ffffff;\r\n  padding: 5px; /* Reduce padding */\r\n  border-radius: 6px;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1); /* Lighter shadow */\r\n  font-size: 12px; /* Adjust font size for compact view */\r\n  font-weight: bold;\r\n  color: #333;\r\n  height: 50px; /* Reduce height to fit card */\r\n  position: relative; /* Needed for fine-tuning */\r\n}\r\n\r\n\r\n.platform-metric span {\r\n  margin-bottom: 10px; /* Move value slightly up */\r\n}\r\n/* Icons are smaller but still visible */\r\n.platform-metric .platform-icon {\r\n  font-size: 16px; /* Increase size slightly */\r\n  margin-bottom: -5px; /* Move icon closer to value */\r\n  position: absolute;\r\n  top: 16px; /* Adjust top position for better alignment */\r\n  left: 50px;\r\n  transform: translateX(-50%);\r\n}\r\n\r\n/* Twitter Icon */\r\n.platform-metric .fa-twitter {\r\n  color: #1DA1F2 !important; /* Twitter blue */\r\n}\r\n\r\n/* Facebook Icon */\r\n.platform-metric .fa-facebook {\r\n  color: #1877F2 !important; /* Facebook blue */\r\n}\r\n\r\n/* Instagram Icon */\r\n.platform-metric .fa-instagram {\r\n  color: #E4405F !important; /* Instagram pink */\r\n}\r\n\r\n/* TikTok Icon */\r\n.platform-metric .fa-tiktok {\r\n  color: #000000 !important; /* TikTok black */\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
